var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09297 11.0524C2.90886 11.1138 2.74157 11.2172 2.60434 11.3544C2.46712 11.4916 2.36372 11.6589 2.30234 11.843L0 18.7501L0.183203 18.9333L3.81172 15.3048C3.78594 15.2048 3.75039 15.1083 3.75039 15.0001C3.75039 14.3098 4.31016 13.7501 5.00039 13.7501C5.69062 13.7501 6.25039 14.3098 6.25039 15.0001C6.25039 15.6903 5.69062 16.2501 5.00039 16.2501C4.89219 16.2501 4.7957 16.2145 4.6957 16.1887L1.06719 19.8173L1.25 20.0001L8.15703 17.6977C8.34117 17.6364 8.50849 17.533 8.64573 17.3958C8.78296 17.2586 8.88634 17.0912 8.94766 16.9071L10.2395 13.6231L6.37695 9.76062L3.09297 11.0524ZM14.4238 1.10632L7.27109 8.8989L11.0934 12.7212L18.8859 5.56843C22.2031 2.63601 17.3332 -2.18509 14.4238 1.10632Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.a9f9a720.svg";
export { ForwardRef as ReactComponent };